// extracted by mini-css-extract-plugin
export default {"billing-summaries-studios-select":"billing-summaries-studios-select_giqEz"};